import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthenticateService } from '../../../../common/services/Authenticate.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

declare var $: any;

@Component({
  selector: 'app-register-icheck',
  templateUrl: './register-icheck.component.html',
  styleUrls: ['./register-icheck.component.css']
})
export class RegisterIcheckComponent implements OnInit {

  public datas: any = [];
  public loginForm: FormGroup;
  public model: any = {};
  public token_link: string = '';
  public isRedirectOTP: boolean = false;
  public counter: number = 10;
  public tokenAccountIcheck: any;
  public errorMsg: any;
  public phoneRegister: any;
  langSubscription: Subscription;
  placeholders: any = {};
  currentLang: string = 'vi';

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private authenticateService: AuthenticateService,
    private translate: TranslateService
  ) {
  }

  startCoutdowm() {
    if (this.counter > 0) {
      this.doCountdown();
    }
  }

  doCountdown() {
    console.log('thisdsdasd.áddsa', this.counter)
    if (this.counter > 0) {
      setTimeout(() => {
        this.counter = this.counter - 1;
        this.processCountdown();
      }, 1000)
    }
  }

  processCountdown() {
    if (this.counter == 0) {
      console.log('count is ', this.counter);
    } else if (this.counter > 0) {
      this.doCountdown();
    } else {
      this.counter = 0;
    }
  }

  ngOnInit() {
    this.updatePlaceholders();
    this.langSubscription = this.translate.onLangChange.subscribe(() => {
      this.updatePlaceholders();
    });

    const inputs = $('#otp').find('input')
    console.log('asdasdasd', inputs)
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('keydown', function (event) {
        console.log(123123123)
        if (event.key === 'Backspace') {
          inputs[i].value = '';
          if (i !== 0) {
            inputs[i - 1].focus();
          }
        } else {
          if (i === inputs.length - 1 && inputs[i].value !== '') {
            return true;
          } else if (event.keyCode > 47 && event.keyCode < 58 || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode === 39) {
            inputs[i].value = event.key;
            if (i !== inputs.length - 1) {
              inputs[i + 1].focus();
            }
            event.preventDefault();
          } else if (event.keyCode > 64 && event.keyCode < 91) {
            inputs[i].value = String.fromCharCode(event.keyCode);
            if (i !== inputs.length - 1) {
              inputs[i + 1].focus();
            }
            event.preventDefault();
          }
        }
      });
    }
  }

  changeLanguage(lang: string) {
    this.currentLang = lang;
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }

  updatePlaceholders() {
    this.translate.get([
      'RI_NHAP_SO_DIEN_THOAI',
      'RI_MAT_KHAU',
      'RI_NHAP_LAI_MAT_KHAU',
    ]).subscribe((t: any) => {
      this.placeholders = {
        phone: t['RI_NHAP_SO_DIEN_THOAI'],
        password: t['RI_MAT_KHAU'],
        confirmPassword: t['RI_NHAP_LAI_MAT_KHAU'],
      };
    });
  }

  onSubmit(data) {
    this.tokenAccountIcheck = '';
    const body = {
      phoneNumber: data.username && data.username.trim() !== '' ? data.username.trim() : '',
      password: data.password && data.password.trim() !== '' ? data.password.trim() : '',
      confirmPassword: data.confirm_password && data.confirm_password.trim() !== '' ? data.confirm_password.trim() : '',
    };
    this.phoneRegister = body.phoneNumber
    console.log('body', body);
    this.authenticateService.registerIcheckAccout(body).subscribe(
      (res) => {
        if (res.statusCode == '200') {
          this.isRedirectOTP = true;
          this.tokenAccountIcheck = res.data.token;
          this.counter = 60
          this.startCoutdowm();
        } else {
          this.toastr.error(res.message, this.translate.instant('THAT_BAI'), {
            timeOut: 5000,
          });
        }
      },
      (error) => {
        this.toastr.error(error.message, this.translate.instant('THAT_BAI'), {
          timeOut: 5000,
        });
      }
    );
  }

  backRegister() {
    this.isRedirectOTP = false;
    this.tokenAccountIcheck = '';
    this.counter = 0;
  }

  reSendOTP() {
    if (this.counter == 0) {
      this.counter = 60;
      this.startCoutdowm();
    }
    const body = {
      token: this.tokenAccountIcheck
    }
    this.authenticateService.resendOTP(body).subscribe(
      (res) => {
        if (res.statusCode == '200') {
          this.toastr.success(
            this.translate.instant('MA_OTP_DA_DUOC_GUI_VE_THIET_BI'),
            this.translate.instant('THANH_CONG_COLON'),
            {
              timeOut: 3000,
              positionClass: 'toast-bottom-right',
            });
        } else {
          this.toastr.error(res.message, this.translate.instant('THAT_BAI'), {
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
          });
        }
      },
      (error) => {
        this.toastr.error(error.message, this.translate.instant('THAT_BAI'), {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
      }
    );
  }

  confirmRegister() {
    this.errorMsg = ''
    const inputs = $('#otp').find('input')
    const otp = []
    for (let i = 0; i < inputs.length; i++) {
      otp.push(inputs[i].value)
    }
    const convertOPT = otp.toString().split(',').join('')
    console.log('inputsinputsinputs', convertOPT);
    if (convertOPT == '') {
      this.toastr.error(
        this.translate.instant('RI_OTP_KHONG_DE_TRONG'),
        this.translate.instant('THONG_BAO_1'),
        {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
    } else {
      const body = {
        otp: convertOPT,
        token: this.tokenAccountIcheck
      }
      this.authenticateService.confirmOTP(body).subscribe(
        (res) => {
          if (res.statusCode == '200') {
            this.errorMsg = '';
            this.router.navigate(['/login']);
          } else {
            this.errorMsg = res.message
            console.log(123)
          }
        },
        (error) => {
          this.errorMsg = error.message
          console.log('this.errorMsg', this.errorMsg)
          // this.toastr.error(error.message, 'Thất bại', {
          //   timeOut: 3000,
          //   positionClass: 'toast-bottom-right',
          // });
        }
      );
    }

  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {
    localStorage.removeItem('token_link');
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/auth/register-icheck/register-icheck.component.ts